import { useQuery } from '@tanstack/react-query';
import { PropBotTradeHistoryService, MergedTradeHistoryItem, TradingHistoryWithSource } from '@/services/prop-bot/prop-bot-trade-history-service';

export const usePropMergedTradingHistory = (botId: string) => {
  return useQuery({
    queryKey: ['propMergedTradingHistory', botId],
    queryFn: () => PropBotTradeHistoryService.getMergedTradingHistoryWithSource(botId),
    enabled: !!botId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};